import { IEvent } from "@quest/adapter-interface";
import { BaseViewBehavior } from "@quest/murka-games-behavior-panther/dist";
import { ingenuity } from "@quest/base-core";

export class CascadingReelPanelView extends BaseViewBehavior {
  protected resize(e?: IEvent): void {
    if (!ingenuity.deviceEnv.isDesktop) {
      if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
        this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
        this.updateOrientation();
      }
    }
  }
}
